import * as h from "../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
const { vec2: x } = h, w = (o = x(0), i = 0.02, t = 1, d = 1) => {
  const {
    vec2: l,
    sin: m,
    cos: a,
    time: s
  } = h, c = d * 1.618033988749895, n = d * 2.718281828459045, u = (Math.sin(d) + 2) * 5, r = (Math.cos(d) + 2) * 5, f = l(
    m(o.x.mul(t).mul(u).add(s.mul(0.1)).add(c)),
    a(o.y.mul(t).mul(u).add(s.mul(0.1)).add(n))
  ), p = l(
    m(o.y.mul(t).mul(r).add(s.mul(0.05)).add(n)),
    a(o.x.mul(t).mul(r).add(s.mul(0.05)).add(c))
  ), M = f.add(p).mul(i);
  return o.add(M);
};
export {
  w as distort
};
